import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import validator from "validator";
import { useAuth } from "../hooks/useAuth";
import Campusback from '../../images/campus-bg-min.jpg';
import logo from '../../images/tiutLogo.png';

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";
const studentImages = [
    "/images/students/jpeg-optimizer_DSC03384.JPG",
    "/images/students/jpeg-optimizer_DSC03387.JPG",
    "/images/students/jpeg-optimizer_DSC03397.JPG",
    "/images/students/jpeg-optimizer_DSC03481.JPG",
    "/images/students/jpeg-optimizer__D560051.JPG",
    "/images/students/jpeg-optimizer__D560069.JPG",
    "/images/students/jpeg-optimizer__D560115.JPG",
];

function Login() {
    const [form, setForm] = useState({
        email: "",
        password: "",
    });
    
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const [step, setStep] = useState(1);
    const { login,token } = useAuth(); // get the login function
    const navigate = useNavigate();
    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const validate = () => {
        let newErrors = {};
        if (!validator.isEmail(form.email)) newErrors.email = "Invalid email";
        if (!validator.isLength(form.password, { min: 6 }))
            newErrors.password = "Password must be at least 6 chars";
        return newErrors;
    };

    const handleLogin = (e) => {
        e.preventDefault();
        let newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            console.log("Errors:", newErrors);
            console.log("Form:", form);
        } else {
            setErrors({});
            console.log("Submit form:", form);
            setLoader(true);
            fetch(`/api/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(form),
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else if (response.status === 401) {
                        setLoader(false);
                        setErrors({email: "Invalid credentials"});
                    } else if (response.status === 404){
                        setLoader(true);
                        fetch(`/api/send-otp`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({email: form.email}),
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            setLoader(false);
                            setStep(2);
                           console.log(data);
                            
                        })
                    } else {
                        throw new Error(response.statusText);
                    }
                })
                .then((data) => {
                    if (data.extraerror) {
                        setLoader(false);
                        setErrors(data.extraerror); 
                    }else if (data.access_token) {
                      
                        login(data.access_token);
                        console.log("login",token);
                        setTimeout(() => {
                            setLoader(false);
                            navigate("/");
                        }, 1000);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    };



        // OTP validation logic
        const [otp, setOtp] = useState({
          otp: "",
        });
        const [otpErrors, setOtpErrors] = useState({});
        const handleOTPChnage =(e) =>
          setOtp({ ...otp, [e.target.name]: e.target.value 
        });
        const OtpValidator = () => {
            let newErrors = {};
            if (validator.isEmpty(otp.otp)) newErrors.otp = "OTP is required";
            return newErrors;
        };
        const handleOtp = (e) =>{
          e.preventDefault();
          setLoader(true);
          let newErrors = OtpValidator();
          setOtpErrors(newErrors);
          if(Object.keys(newErrors).length > 0){
            setOtpErrors(newErrors);
          }else{
            setOtpErrors({});
            fetch(`/api/verify-otp`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({otp: otp.otp,
                email: form.email,
                password: form.password
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.extraerror) {
                  setLoader(false);
                  setOtpErrors(data.extraerror);
                }
                else if (data.access_token) {
                    login(data.access_token);
                    setLoader(false);
                    navigate("/");
                }
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        };
    return (
        <div>
            {loader && <div className="preloader"></div>}
            <div className="nav-header postion-sticky top-0 bg-white shadow-none border-0">
                <div className="nav-top justify-content-between w-100">
                    <a href="/"><img src={logo} className="logo" alt="logo" style={{width:"150px"}} /> </a>

                    <Link
                        to="/register"
                        className="mob-menu ms-auto me-2 chat-active-btn text-grey-900 font-sm btn-round-md bg-greylight px-3 py-2"
                        style={{ height: "unset" }}
                    >
                        Register <i className="feather-log-in " />
                    </Link>

                    <Link
                        to="/register"
                        className="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl"
                    >
                        Register
                    </Link>
                </div>
            </div>

            <div className="row g-0">
                <div
                    className="col-xl-7 p-0 vh-100 position-relative overflow-hidden d-none d-xl-block"
                    style={{ backgroundColor: "#1a1a1a" }}
                >
                    <Swiper
                        modules={[Autoplay, EffectFade, Pagination, Navigation]}
                        effect="fade"
                        speed={1000}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        loop={true}
                        className="w-100 h-100 login-swiper"
                    >
                        {studentImages.map((src, index) => (
                            <SwiperSlide key={index} className="w-100 h-100 position-relative">
                                <img
                                    src={src}
                                    alt={`Student Alumni ${index + 1}`}
                                    className="w-100 h-100"
                                    style={{
                                        objectFit: "cover",
                                        objectPosition: "center top",
                                    }}
                                />
                                <div
                                    className="position-absolute bottom-0 start-0 w-100 p-4 text-start"
                                    style={{
                                        background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%)",
                                        zIndex: 10,
                                    }}
                                >
                                    <span className="badge bg-danger text-white font-xssss px-3 py-1 rounded-pill mb-2">
                                        TIUT Alumni Community
                                    </span>
                                    <h3 className="text-white fw-700 font-lg mb-1">
                                        Empowering Futures, Connecting Generations
                                    </h3>
                                    <p className="text-white-50 font-xssss mb-3">
                                        Join hands with fellow graduates and explore endless networking opportunities.
                                    </p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                {step === 1 && 
                
                
                <div className="col-xl-5 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
                    <div className="card shadow-none border-0 ms-auto me-auto login-card">
                        <div className="card-body rounded-0 text-left">
                            <h2 className="fw-700 display1-size display2-md-size mb-3">
                                Login into <br />
                                your account
                            </h2>
                            <form onSubmit={handleLogin}>
                                <div className="form-group icon-input mb-3">
                                    <i className="font-sm ti-email text-grey-500 pe-0" />
                                    <input
                                        type="email"
                                        className="style2-input ps-5 form-control text-grey-900 font-xsss fw-600"
                                        placeholder="Your Email Address"
                                        name="email"
                                        onChange={handleChange}
                                        autoComplete="email"
                                    />
                                    {errors.email && (
                                        <span className="text-danger">{errors.email}</span>
                                    )}
                                </div>
                                <div className="form-group icon-input mb-1">
                                    <input
                                        type="password"
                                        className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"
                                        placeholder="Password"
                                        name="password"
                                        onChange={handleChange}
                                        autoComplete="current-password"
                                    />
                                    <i className="font-sm ti-lock text-grey-500 pe-0" />
                                </div>
                                <div className="form-group icon-input mb-1 my-4">
                                    <button
                                        type="submit"
                                        className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0"
                                    >
                                        Login
                                    </button>
                                </div>
                                <div className="form-check text-left mb-3">
                                    {/* <input type="checkbox" className="form-check-input mt-2" id="exampleCheck5" /> */}
                                    {/* <label className="form-check-label font-xsss text-grey-500" htmlFor="exampleCheck5">Remember me</label> */}
                                    {/* <Link
                                        to={"/forgot"}
                                        className="fw-600 font-xsss text-grey-700 mt-1 float-right"
                                    >
                                        Forgot your Password?
                                    </Link> */}
                                </div>
                            </form>
                            <div className="col-sm-12 p-0 text-left">
                                <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">
                                    Dont have account?
                                    <Link
                                        to="/register"
                                        className="fw-700 ms-1"
                                    >
                                        Register
                                    </Link>{" "}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
                }

                 {step === 2 && 
                                <div className="col-xl-5 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
                                    <div className="card shadow-none border-0 ms-auto me-auto login-card">
                                        <div className="card-body rounded-0 text-left">
                                            <h2 className="fw-700 display1-size display2-md-size mb-4">
                                                OTP <br />
                                                Verifications
                                            </h2>
                                            <form onSubmit={handleOtp}>
                                                <div className="form-group icon-input mb-3">
                                                    <i className="font-sm ti-lock text-grey-500 pe-0" />
                                                    <input
                                                        type="text"
                                                        className="style2-input ps-5 form-control text-grey-900 font-xsss fw-600"
                                                        name="otp"
                                                        placeholder="Enter OTP"
                                                        onChange={handleOTPChnage}
                                                    />
                                                    {otpErrors.otp && <p>{otpErrors.otp}</p>}
                                                </div>
                                                  <div className=" text-left mb-3">
                                                   
                                                    <label
                                                        className=" font-xsss text-grey-500"
                                                       
                                                    >
                                                       An OTP has been sent to your email {form.email}
                                                    </label>
                                                 
                                                    {/* <a href="#" class="fw-600 font-xsss text-grey-700 mt-1 float-right">Forgot your Password?</a> */}
                                                </div>
                                                <button
                                                    type="submit"
                                                    className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0"
                                                    style={{ height: "40px" }}
                                                >
                                                    Verify
                                                </button>
                                            </form>
                                            <div className="col-sm-12 p-0 text-left">
                                                <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">
                                                    Already have account?
                                                    <Link to="/login" className="fw-700 ms-1">
                                                        Login
                                                    </Link>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
            </div>
        </div>
    );
}

export default Login;
